<template>
  <el-dialog center width="630px" top="-20vh" :visible.sync="open" :modal-append-to-body="false">
    <div slot="title" class="header-title">
      <div style=" font-size: 16px; font-weight: bold;">添加链接设置</div>
    </div>
    <div class="link-cont">
      <div class="cont-box">
        <div class="box-item">
          <div class="item">
            <div class="item-input">
              <div class="item-title">链接作品名称</div>
              <el-input v-model="ruleForm.title"></el-input>
            </div>
            <span class="add-img-ts">
              为保证最佳效果，建议尺寸：765px * 1031px
            </span>
            <div class="item-input">
              <div class="item-title" style="width: 140px;">上传作品封面</div>
              <div class="item-but" @click="addImgs">
                <input type="file" id="uploadCusBg" value="imgFile" ref="coverImg" accept="image/png, image/jpeg, image/jpg" @change="uploadImg($event)" style="display: none;" />
                上传+
              </div>
            </div>
            <div class="item-input" style="margin-top: 15px;">
              <div class="item-title">设置作品链接</div>
              <el-input v-model="ruleForm.url"></el-input>
            </div>
          </div>
        </div>
        <div class="set-button">
          <div id="" class="but1" @click="sendSetQx">
            取消
          </div>
          <div id="" class="but2" @click="sendSet" :disabled="saveDisabled">
            确定
          </div>
        </div>
      </div>
      <div class="cont-img">
        <div class="back-cont">
          <img class="back-img" :src="ruleFormBackgroud" v-if="ruleFormBackgroud !== ''" />
        </div>
        <img class="bott-img" src="../../../assets/imgs/yldz.png" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AddLinks',
  data() {
    return {
      saveDisabled: false,
      open: false,
      ruleForm: {
        title: '链接作品',
        url: '',
        backgroud: '',
        creator: '',
        coverSize: '765,1031'
      },
      isHx: false,
      ruleFormBackgroud: ''
    }
  },
  components: {},
  computed: {
    creator() {
      return this.$store.state.common.userName
    }
  },
  props: {
    type: {
      type: Number,
      default: () => {
        return 0
      }
    },
    echoData: {
      type: Object,
      default: () => {
        return { title: '链接作品', url: '', backgroud: '', creator: '', coverSize: '765,1031' }
      }
    }
  },
  watch: {
    echoData: {
      immediate: true, // immediate选项可以开启首次赋值监听
      handler(newVal, oldVal) {
        this.isHx = true
        this.ruleForm = newVal
        this.ruleFormBackgroud = newVal.backgroud
      }
    }
  },
  methods: {
    // 取消
    sendSetQx() {
      this.open = false
      this.$emit('undataPage')
    },
    // 确定
    sendSet() {
      let title = this.ruleForm.title.trim()
      if (this.ruleForm.url == '' || title == '' || this.ruleFormBackgroud == '') {
        this.$message({
          message: '请完成作品设置',
          type: 'warning'
        })
      } else {
        this.ruleForm.creator = this.creator
        this.$emit('addLinkImg', this.ruleForm, this.type)
      }
    },
    addImgs() {
      if (this.$refs.coverImg) {
        this.$refs.coverImg.value = ''
      }
      this.$refs.coverImg.click()
    },
    uploadImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      const fileSize = file.size
      const isLt2Mb = fileSize / 1024 / 1024 < 1
      if (!isLt2Mb) {
        this.$message({
          message: '请上传小于1M的封面图片',
          type: 'error'
        })
        file = ''
        return
      }

      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.ruleFormBackgroud = res.target.result
        _this.$emit('getFile', file, _this.ruleForm.backgroud)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.link-cont {
  display: flex;
  .cont-box {
    width: 50%;
    display: flex;
    flex-direction: column;
    .box-item {
      border: 1px solid #f4f4f4;
      padding: 10px 15px;
      .item {
        display: flex;
        flex-direction: column;
        .item-input {
          margin-top: 5px;
          display: flex;
          /deep/ .el-input__inner {
            height: 30px !important;
          }
          .item-title {
            width: 135px;
            line-height: 30px;
            font-size: 14px;
            padding-right: 5px;
          }
          .item-but {
            cursor: pointer;
            background-color: #df5813;
            color: #fff;
            width: 250px;
            height: 35px;
            line-height: 35px;
            text-align: center;
          }
        }
        .add-img-ts {
          color: #e15715;
          font-size: 10px;
          padding-top: 10px;
        }
      }
    }
  }
  .cont-img {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .back-cont {
      background-color: #fff7ed;
      width: 178px;
      height: 208px;
      .back-img {
        width: 100%;
        height: 100%;
      }
    }

    .bott-img {
      margin: 0 auto;
    }
  }
}
.set-button {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  div {
    width: 109px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
  .but1 {
    background-color: #999999;
    margin-right: 10px;
  }
  .but2 {
    margin-left: 10px;
    background-color: #df5813;
  }
}
/deep/ .el-dialog__header {
  // padding: 12px !important;
  background-color: #f4f4f4;
}
</style>
